import * as React from "react";
import { Component } from "react";
import { Button, Glyphicon, Nav } from "react-bootstrap";
import { Redirect } from "react-router";
import { IBaseState } from "src/interfaces";
import "../../css/App.css";
import { INavbarProps } from "./interfaces";

export default class SignedInLinks extends Component<INavbarProps, IBaseState> {
  public constructor(props: INavbarProps) {
    super(props);

    this.state = {
      loading: true,
    };

    this.signOut = this.signOut.bind(this);
  }

  public componentDidMount() {
    this.setState({ loading: false });
  }

  public render() {
    const { appService } = this.props;
    if (!appService.isAuthenticated()) {
      return <Redirect to="/login" />;
    }

    const profile = appService.getProfile();
    return (
      <Nav pullRight={true}>
        <Button
          onClick={this.signOut}
          bsSize="small"
          bsStyle="warning"
          className="button-left button-right button-top-margin-times-two"
        >
          <Glyphicon glyph="glyphicon glyphicon-log-out" />
        </Button>
        <Button className="button-middle-center button-top-margin-times-two" bsSize="small">
          {profile ? (profile.initials ? profile.initials : "[]") : "[]"}
        </Button>
      </Nav>
    );
  }

  private signOut() {
    const { appService, history } = this.props;
    appService.logout(history).then(() => {
      this.props.setUser(null);
      this.props.appService.resetActiveProject();
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/SignedInLinks.tsx